<template>
  <div class="wrapper">
    <div class="logo" />
    <div class="error-title">
      <template v-if="error?.statusCode === 404">
        ページが見つかりません。
      </template>
      <template v-else-if="error?.statusCode === 500">
        エラーが発生しました。
      </template>
      <template v-else-if="error?.statusCode === 401">
        アクセスできません。
      </template>
      <template v-else-if="error?.statusCode === 403">
        アクセスできる権限がありません。
      </template>
      <template v-else>
        エラーが発生しました。
      </template>
    </div>
    <div class="error-description">
      <template v-if="error?.statusCode === 404">
        お探しのページが見つかりませんでした。
        <br>
        URLをお確かめください。
      </template>
      <template v-else-if="error?.statusCode === 500">
        お探しのページを表示できません。
        <br>
        時間をおいてから、再度お試しください。
      </template>
      <template v-else-if="error?.statusCode === 401">
        このページへのアクセスは許可されていません。
        <br>
        URLをお確かめください。
      </template>
      <template v-else-if="error?.statusCode === 403">
        このページへのアクセス権限がありません。
        <br>
        管理者にお問い合わせください。
      </template>
      <template v-else>
        お探しのページを表示できません。
        <br>
        時間をおいてから、再度お試しください。
      </template>
    </div>
    <div class="top-link">
      <NuxtLink :to="topPagePath">
        トップページへ移動する
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  error: any
}>()

const topPagePath = computed(() => {
  if (localStorage.getItem('isGuest') === 'true') {
    return '/guest/'
  } else {
    return '/'
  }
})
</script>

<style lang="sass" scoped>
.wrapper
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  height: 80vh

.logo
  width: 133px
  height: 200px
  background: url('~/assets/logo_vertical.png') center / contain no-repeat

.error-title
  color: #222222
  font-size: 18px
  margin-top: 75px
  margin-bottom: 30px
  text-align: center
  font-weight: bold

.error-description
  color: #222222
  font-size: 18px
  line-height: 27px
  text-align: center

.top-link
  margin-top: 30px
  position: relative
  a
    color: #ac712a
    &:active,
    &:focus,
    &:hover,
    &:visited
      color: #ac712a
    &:after
      position: absolute
      top: 8px
      right: -15px
      content: ''
      width: 12px
      height: 12px
      background: url('~/assets/icons/caret_right.svg') center / contain no-repeat
</style>

